import type { User } from '@/api/types'
import { ScrollArea } from '@/components/ui/scroll-area'
import { UserTopbar } from '@/components/layout/UserTopbar'
import { InvitesCtx, useInvitesPoll } from '@/hooks/useInvites'
import { UserScreens } from './routes'

// 사용자의 껍데기: 레일도 사이드바도 없고, 관리자 목록을 읽지 않는다.
// 내게 온 초대(F-92)만 여기서 한 번 읽어 상단 바의 표시와 팀 화면이 나눠 본다.
export function UserShell({ user, onLogout }: { user: User; onLogout: () => void }) {
  const invites = useInvitesPoll()
  return (
    <InvitesCtx.Provider value={invites}>
      <div className="flex h-dvh flex-col overflow-hidden">
        <UserTopbar user={user} invites={invites.list?.length ?? 0} onLogout={onLogout} />
        <ScrollArea className="min-h-0 flex-1">
          <main className="mx-auto max-w-4xl px-6 pt-4 pb-12 max-sm:px-4">
            <UserScreens />
          </main>
        </ScrollArea>
      </div>
    </InvitesCtx.Provider>
  )
}
